import { IApplicationState } from '../../types/redux';
import { getSiteType } from '../getSiteType';
import { PAGE_TYPE } from '../../constants/pageType';

export function createCianAnalyticsPageViewObject(state: IApplicationState) {
  const { servicePage, user } = state;

  return {
    user: {
      userId: user.userId,
    },
    page: {
      pageType: PAGE_TYPE,
      siteType: getSiteType(servicePage.deviceType),
    },
  };
}
